export default {"src":"/_next/static/media/CHECKLIST_ACTIVE.f6cd3068.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};